
import { createSlice } from '@reduxjs/toolkit';

export const AcsActiveAlarmSlice = createSlice({
    name: 'acsActiveAlarmSlice',
    initialState: {
        loading: false,
        data: {

        },
        alarms:[],
        error: false,
    },
    reducers: {
        ACS_ACTIVE_ALARM_FETCH_START: (state) => {
            state.loading = true
        },
        ACS_ACTIVE_ALARM_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.alarms = action.payload.alarms
        },
        ACS_ACTIVE_ALARM_FETCH_LOAD_MORE: (state, action) => {
            state.loading = false
            state.data = action.payload
            state.alarms = [...state.alarms, ...action.payload.alarms]
        },
        ACS_ACTIVE_ALARM_HISTORY_EDIT_SUCCESS: (state, action) => {
            state.loading = false
            console.log(action.payload)
            const newArray = state.alarms.filter(todo => todo.id !==action.payload.id)
             state.alarms = [...newArray,action.payload]
        },
        ACS_ACTIVE_ALARM_FETCH_ERROR: (state) => {
            state.error = true
            state.loading = false
        }
    }
});

export const {ACS_ACTIVE_ALARM_HISTORY_EDIT_SUCCESS, ACS_ACTIVE_ALARM_FETCH_START, ACS_ACTIVE_ALARM_FETCH_SUCCESS, ACS_ACTIVE_ALARM_FETCH_ERROR, ACS_ACTIVE_ALARM_FETCH_LOAD_MORE } = AcsActiveAlarmSlice.actions;
export default AcsActiveAlarmSlice.reducer;